// /src/renderer/analysis/rendering/registerPanels.ts
import { registerPanel } from './panelRegistry';

import EmptyPanel from './Panels/Renderers/EmptyPanel';
import DICOMPanel from './Panels/Renderers/DICOMPanel';
import VRPanel from './Panels/Renderers/VRPanel';
import Surface3DPanel from './Panels/Renderers/Surface3DPanel';
import ReportPanel from './Panels/Renderers/ReportPanel';
import CPRPanel from './Panels/cprPanel/CPRPanel';
import CrossSectionPanel from './Panels/Renderers/CrossSectionPanel';
import PlotPanel from '../analysisChart/PlotPanel';

// 공통 패널 등록
export function registerDefaultPanels() {
  registerPanel('Empty', EmptyPanel);
  registerPanel('Axial', DICOMPanel);
  registerPanel('Coronal', DICOMPanel);
  registerPanel('Sagittal', DICOMPanel);
  registerPanel('FourChamber', DICOMPanel);
  registerPanel('TwoChamber', DICOMPanel);
  registerPanel('ShortAxis', DICOMPanel);
  registerPanel('Direction', DICOMPanel);

  registerPanel('VR', VRPanel);
  registerPanel('Surface3D', Surface3DPanel);
  registerPanel('WallThickness', Surface3DPanel);

  registerPanel('Report', ReportPanel);
  registerPanel('CPR', CPRPanel);
  registerPanel('CrossSection', CrossSectionPanel);

  registerPanel('Graph', PlotPanel);
  registerPanel('Histogram', PlotPanel);
}
